import { combineReducers } from 'redux';
import qs from 'qs';

import { Api } from 'core/api';

export const countriesListApi = new Api({
  initialData: [],
  useEagleApi: true,
  namespace: 'COUNTRIES_LIST',
  url: '/internal-intranet/search/references/countries',
});

export const fetchCountries = ({ search, hash }: any) => {
  let searchString = '';

  if (hash) {
    searchString = hash.split('#')[1];
  }
  const params = qs.parse(search.slice(1));
  const body = JSON.stringify({
    page: +params.page || 0,
    pageSize: +params.limit || 10,
    sort: { order: [{ direction: 'ASC', property: 'name' }] },
    filter: searchString
      ? {
          filters: [
            {
              property: 'name',
              type: 'containsIgnoreCase',
              value: searchString,
            },
          ],
        }
      : null,
  });

  return countriesListApi.fetch({
    options: {
      method: 'POST',
      body,
    },
  });
};

const countryItemApi = new Api({
  initialData: {},
  namespace: 'COUNTRY_ITEM',
  useEagleApi: true,
});

export const fetchCountryInfo = (id: string) =>
  countryItemApi.fetch({
    url: `/internal-intranet/references/countries/${id}`,
  });

export const resetCountryInfo = countryItemApi.reset;

const editCountryApi = new Api({
  namespace: 'EDIT_COUNTRY',
  options: {
    method: 'PUT',
  },
  useEagleApi: true,
});

export const editCountry = (id: string, data: any) =>
  editCountryApi.fetch({
    options: { body: JSON.stringify(data) },
    url: `/internal-intranet/references/countries/${id}`,
  });

export const reducer = combineReducers({
  item: countryItemApi.reducer,
  list: countriesListApi.reducer,
});
